"use client";

import Icon from "@/components/library/Icon";
import {cn} from "@/lib/utils";
import StepStatusIcon from "./StepStatusIcon";

type StepRowProps = Readonly<{
   expandable: boolean;
   open: boolean;
   completed: boolean;
   failed: boolean;
   title: string;
   chipText: string | null;
   /** Hide the chip while the code block is expanded — it would duplicate it. */
   chipHidden: boolean;
}>;

export default function StepRow({
   expandable,
   open,
   completed,
   failed,
   title,
   chipText,
   chipHidden,
}: StepRowProps) {
   return (
      <>
         <span className="flex h-4 w-3 flex-shrink-0 items-center justify-center">
            {expandable && (
               <Icon
                  icon="chevron-right"
                  className={cn(
                     "h-2.5 w-2.5 text-300 transition-transform duration-150",
                     open && "rotate-90"
                  )}
               />
            )}
         </span>
         <span className="flex h-3 w-3 flex-shrink-0 items-center justify-center">
            <StepStatusIcon completed={completed} failed={failed} />
         </span>
         <span
            className={cn(
               "flex-shrink-0 text-xs leading-5",
               completed ? "text-600" : "font-medium text-600 animate-text-shimmer"
            )}
         >
            {title}
         </span>
         {chipText ? (
            <span
               className={cn(
                  "min-w-0 flex-1 truncate font-mono text-[11px] leading-5 transition-colors duration-150",
                  failed ? "text-destructive" : "text-400",
                  chipHidden && "opacity-0"
               )}
            >
               {chipText}
            </span>
         ) : (
            <span className="min-w-0 flex-1" />
         )}
      </>
   );
}
